module.exports = __webpack_public_path__ + "img/su-instruce.a1f52118.png";